import { motion } from "framer-motion";
import { Leaf } from "lucide-react";

const viewport = { once: true, amount: 0.3 };

export default function About() {
  return (
    <section id="o-projekcie" className="py-20 md:py-32 bg-surface border-y border-line">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={viewport}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="absolute -inset-4 border border-gold/40 rounded-2xl -translate-x-4 -translate-y-4" aria-hidden />
          <img
            src="https://images.pexels.com/photos/11692283/pexels-photo-11692283.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Detale natury — żyłki liści"
            className="relative w-full h-[340px] md:h-[440px] object-cover rounded-2xl shadow-clay"
            data-testid="about-image"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewport}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="inline-flex items-center gap-2 text-sm font-outfit uppercase tracking-[0.2em] text-gold">
            <Leaf className="h-4 w-4" strokeWidth={1.5} /> O projekcie
          </span>
          <h2 className="mt-5 font-outfit font-medium text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ink leading-tight" data-testid="about-title">
            Tam, gdzie pasja do natury spotyka nowoczesną technologię
          </h2>
          <p className="mt-6 font-manrope text-base md:text-lg text-ink-soft leading-relaxed" data-testid="about-text">
            „Złap Kod Natury” powstało z przekonania, że lekcje przyrody i geografii mogą być
            prawdziwą przygodą. Łączymy fascynację światem natury z grywalizacją i sztuczną
            inteligencją, by każda lekcja angażowała uczniów na nowo.
          </p>
          <p className="mt-4 font-manrope text-base md:text-lg text-ink-soft leading-relaxed">
            Pokazujemy nauczycielom, jak projektować zaszyfrowane zagadki, budować escape roomy
            i wykorzystywać AI jako asystenta — by mieć więcej czasu na to, co naprawdę ważne:
            ciekawość i rozwój uczniów.
          </p>

          <div className="mt-9 grid grid-cols-3 gap-6 border-t border-line pt-7">
            {[
              { n: "20+", l: "Gotowych scenariuszy" },
              { n: "AI", l: "Prompty dla nauczycieli" },
              { n: "100%", l: "Frajdy na lekcji" },
            ].map((s) => (
              <div key={s.l} data-testid={`about-stat-${s.n}`}>
                <div className="font-outfit text-2xl md:text-3xl text-forest font-medium">{s.n}</div>
                <div className="mt-1 font-manrope text-xs md:text-sm text-ink-soft">{s.l}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
